import { ReactNode } from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export type PageTitleProps = {
  title: string;
  addButton?: ReactNode;
  action?: ReactNode;
};

export function PageTitle(pageTitleProps: PageTitleProps) {
  const { title, addButton, action } = pageTitleProps;

  return (
    <Stack direction='row' alignItems='center' justifyContent='space-between'>
      <Stack direction='row' alignItems='center' justifyContent='flex-start' spacing={2}>
        <Typography variant='h4'>{title}</Typography>

        {addButton}
      </Stack>

      {action ?? <span />}
    </Stack>
  );
}
